import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type DniAnalysisTransformer } from './transformers'

export const removeFromCartTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'remove_from_cart') return event
  const { currency, value, items } = event.eventParams
  if (!items) return event
  if (platform === AnalyticsPlatforms.OMNICHAT) {
    const products = items.map(item => ({
      id: item.item_id || '',
      quantity: item.quantity || 0,
      price: String(item.price || 0),
      name: item.item_name || '',
      variant: item.item_variant || '',
    }))
    return {
      eventName: 'remove_from_cart',
      eventParams: {
        items: products,
        currency,
        value,
      },
    }
  }
  return event
}
